export default {
  "logos": {}
};